import { useDelayedPresence } from "@ui-kit/FloatingPanel/hooks/useDelayedPresence";
import { useState } from "react";
import type { HomeLayoutEditScope } from "../utils/homeLayoutTypes";

export const HOME_LAYOUT_EDIT_BAR_ANIMATION_DURATION = 300;

export const useHomeLayoutEditBarPresence = (editScope: HomeLayoutEditScope | null) => {
	const isOpen = editScope !== null;
	const isPresent = useDelayedPresence(isOpen, HOME_LAYOUT_EDIT_BAR_ANIMATION_DURATION);
	const [lastScope, setLastScope] = useState(editScope);
	if (isOpen && editScope !== lastScope) setLastScope(editScope);

	return {
		scope: isPresent ? (editScope ?? lastScope) : null,
		presenceState: isOpen ? ("open" as const) : ("closed" as const),
	};
};
